<template>
  <div>
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-row class="m-0 bsDriversHeader">
        <b-col> </b-col>
        <b-col class="text-right">
          <downloadChart />
        </b-col>
      </b-row>

      <b-row class="m-0 chartTabPanel autoCursor bsDriversPanel">
        <b-col ref="capture" cols="6" class="py-0">
          <b-card-group deck>
            <!--Card 1-->
            <b-card header="Balance Sheet" header-tag="header" class="m-2 ">
              <div id="financial_summary_tbl" class="tblWrapper">
                <h5 class="px-2">($ millions, except per-share data)</h5>
                <table>
                  <thead id="financial_summary_head">
                    <th>Category</th>
                    <th class="rightAligned">2016A</th>
                    <th class="rightAligned">2017A</th>
                    <th class="rightAligned">2018A</th>
                    <th class="rightAligned">2019E</th>
                    <th class="rightAligned">2020E</th>
                    <th class="rightAligned">2021E</th>
                  </thead>
                  <tbody id="financial_summary_body">
                    <tr
                      v-for="(bItem, index) in balancesheetTableDataLocal"
                      :key="index"
                    >
                      <td>{{ bItem["key"] }}</td>
                      <td class="rightAligned">
                        {{ bItem["2016A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ bItem["2017A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ bItem["2018A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ bItem["2019E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ bItem["2020E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ bItem["2021E"] | roundOff }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div id="key_company_tbl" class="tblWrapper">
                <h5 class="px-2">Cost Assumptions</h5>
                <table>
                  <thead id="financial_summary_head">
                    <th>Category</th>
                    <th class="rightAligned">2016A</th>
                    <th class="rightAligned">2017A</th>
                    <th class="rightAligned">2018A</th>
                    <th class="rightAligned">2019E</th>
                    <th class="rightAligned">2020E</th>
                    <th class="rightAligned">2021E</th>
                  </thead>
                  <tbody id="key_company_body">
                    <tr v-for="(item, id) in analysisTableDataLocal" :key="id">
                      <td>{{ item["key"] }}</td>
                      <td class="rightAligned">
                        {{ item["2016A"] | currencyFormat }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2017A"] | currencyFormat }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2018A"] | currencyFormat }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2019E"] | currencyFormat }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2020E"] | currencyFormat }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2021E"] | currencyFormat }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card>
          </b-card-group>

          <b-card-group deck>
            <b-card
              header="BS Assumptions- Scenario Analysis"
              header-tag="header"
              class="m-2 "
            >
              <b-row class="m-0">
                <table class="assumptnTbl">
                  <thead>
                    <tr>
                      <th></th>
                      <th><img :src="sliderFilter" class="sliderIcon" /></th>
                      <th>
                        <h6>
                          Basic
                          <br />
                          Points
                        </h6>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Accrued comp as a % of Sales
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="value1"
                          @change="sliderValuesChange"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="value1"
                    
                          @change="sliderValuesChange"
                          class="ptContainer"
                          id="accruedPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          A/P as a % of Sales
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="value2"
                     
                          @change="sliderValuesChange"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="value2"
                          @change="sliderValuesChange"
                          class="ptContainer"
                          id="apPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Capex as a % of PP&amp;E
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="value3"
                       
                          @change="sliderValuesChange"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="value3"
                          @change="sliderValuesChange"
                          class="ptContainer"
                          id="capexPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Deferred IT asset as a % of Sales
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="value4"
                       
                          @change="sliderValuesChange"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="value4"
                          @change="sliderValuesChange"
                          class="ptContainer"
                          id="deferredPt"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          Depr as a% of PP&amp;E
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="value5"
                    
                          @change="sliderValuesChange"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="value5"
                          @change="sliderValuesChange"
                          class="ptContainer"
                          id="deprPt"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          DSI (Days sales of inventory)
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="value6"
               
                          @change="sliderValuesChange"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="value6"
                          @change="sliderValuesChange"
                          class="ptContainer"
                          id="dsiPt"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="nameField pt-0">
                          LT deferred revenue as a % of Sales
                        </div>
                      </td>
                      <td>
                        <b-form-input
                          id="range-1"
                          v-model="value7"
                     
                          @change="sliderValuesChange"
                          type="range"
                          min="-5"
                          max="5"
                        ></b-form-input>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model="value7"
                          @change="sliderValuesChange"
                          class="ptContainer"
                          id="ltPt"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-12 mb-3">
                  <button @click="resetSliders" class="btn btn-xs btn-primary text-right">
                    Reset
                  </button>
                </div>
              </b-row>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col ref="capture" cols="6" class="py-0">
          <b-card-group deck>
            <!--Card 2-->
            <b-card
              header="Key Balance Sheet Drivers ($ millions)"
              header-tag="header"
              class="m-2 "
            >
              <div class="filterBtn row m-0">
                <div class="filterBtn mx-auto my-2">
                  <button
                    :class="{'active':filterChartTab=='Cash and cash equivalents'}"
                    class="btn btn-primary btn-xs btnContainer"
                    @click="getbalancesheetChartData('Cash and cash equivalents')"
                  >
                    Gross Cash
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    :class="{'active':filterChartTab=='Debt'}"
                    @click="getbalancesheetChartData('Debt')"
                  >
                    Gross Debt
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    :class="{'active':filterChartTab=='Net Cash'}"
                    @click="getbalancesheetChartData('Net Cash')"
                  >
                    Net Cash
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    :class="{'active':filterChartTab=='Total liabilities'}"
                    @click="getbalancesheetChartData('Total liabilities')"
                  >
                    Liabilities
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    :class="{'active':filterChartTab=='D/E'}"
                    @click="getbalancesheetChartData('D/E')"
                  >
                    D/E
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer"
                    :class="{'active':filterChartTab=='Total assets'}"
                    @click="getbalancesheetChartData('Total assets')"
                  >
                    Assets
                  </button>
                </div>
              </div>
              <div class="chartWrapper" id="keyCompanyChart">
                <Plotly
                  :data="balancesheetChartData"
                  :layout="Linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </div>
            </b-card>
          </b-card-group>

          <b-card-group deck>
            <!--Card 2-->
            <b-card
              header="Key Balance Sheet Drivers per share"
              header-tag="header"
              class="m-2 "
            >
              <div class="filterBtn row m-0">
                <div class="filterBtn mx-auto my-2">
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabAna=='Net Cash per share'}"
                    @click="getanalysisChartData('Net Cash per share')"
                  >
                    NCPS
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabAna=='Cash per share'}"
                    @click="getanalysisChartData('Cash per share')"
                  >
                    CPS
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabAna=='Debt per share'}"
                    @click="getanalysisChartData('Debt per share')"
                  >
                    DPS
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabAna=='Book value per share'}"
                    @click="getanalysisChartData('Book value per share')"
                  >
                    BVPS
                  </button>
                  <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabAna=='Deferred revenue per share'}"
                    @click="getanalysisChartData('Deferred revenue per share')"
                  >
                    DRPS
                  </button>
                  <!-- <button
                    class="btn btn-primary btn-xs btnContainer1"
                    :class="{'active':filterChartTabAna=='Current ratio'}"
                    @click="getanalysisChartData('Current ratio')"
                  >
                    CR
                  </button> -->
                </div>
              </div>
              <div class="chartWrapper" id="valuationChart">
                <Plotly
                  :data="analysisChartData"
                  :layout="analysislayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </div>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
//import bFormSlider from 'vue-bootstrap-slider/es/form-slider';
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";
import sliderFilter from "@/assets/img/sliderImg.png";
export default {
  name: "bsDrivers",
  components: {
    Plotly,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      balancesheet: "balancesheet",
      analysis: "analysis",
      iMost: "iMost",
      isFullScreen: "isFullScreen",
    }),
    iMostChildren() {
      return this.iMost.child;
    },
  },
  data() {
    return {
      chartTitle: "",
      balancesheetTableDataLocal: [],
      analysisTableDataLocal: [],
      sliderValue: [2015, 2020],
      filterChartTab: null,
      filterChartTabAna: null,
      min: 2015,
      max: 2020,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      sliderFilter: sliderFilter,
      fullscreen: false,
      analysisCalc: true,
      balancesheetCalc: true,
      balancesheetChartData: [
        {
          name: "",
          type: "bar",
          x: [],
          y: [],
          yaxis: "y",
          marker: { color: "#EEEEEE" },
        },
        {
          name: "YoY % Change",
          type: "line",
          x: [],
          y: [],
          line: {
            shape: 'spline',
            smoothing: 1.3,
            color: "#4682B4"
          },
          marker: { color: "#4682B4", strokeWidth: "2px" },
          yaxis: "y2",
        },
      ],
      analysisChartData: [
        {
          name: "",
          type: "bar",
          x: [],
          y: [],
          yaxis: "y",
          marker: { color: "#FCD6EA" },
        },
        {
          name: "YoY % Change",
          type: "line",
          x: [],
          y: [],
          line: {
            shape: 'spline',
            smoothing: 1.3,
            color: "#C2E486"
          },
          marker: { color: "#C2E486", strokeWidth: "2px" },
          yaxis: "y2",
        },
      ],
      Linelayout: {
        width: 620,
        height: 300,
        autosize: true,
        margin: {
          l: "auto",
          r: "auto",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },
        yaxis2: {
          titlefont: { color: "#333" },
          tickfont: { color: "#333" },
          overlaying: "y",
          side: "right",
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          ticksuffix: "%",
          fixedrange: true,
          range: [-20, 10],
          nticks: 5,
        },
        legend: {
          x: 0.2,
          y: -0.3,
          orientation: "h",
        },
      },
      analysislayout: {
        width: 620,
        height: 300,
        autosize: true,
        margin: {
          l: "auto",
          r: "auto",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
        
          nticks: 8,
        },
        yaxis2: {
          titlefont: { color: "#333" },
          tickfont: { color: "#333" },
          overlaying: "y",
          side: "right",
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          ticksuffix: "%",
          fixedrange: true,
 
          nticks: 5,
        },
        legend: {
          x: 0.2,
          y: -0.3,
          orientation: "h",
        },
      },

      config: { responsive: true },
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      value5: 0,
      value6: 0,
      value7: 0,
    };
  },

  created() {
    let self = this
    setTimeout(function(){
      let filterChart = self.iMostChildren.filter(
        (item) => "BS Drivers" === item.objectname
      );
      // console.log('filterChart-==',filterChart);
      let snapshopChild = filterChart[0].child;
      for (var i = 0; i < snapshopChild.length; i++) {
        self.getChartDataById({
          id: snapshopChild[i].chartId,
          chartName: snapshopChild[i].objectname,
        });
      }
      //  this.getKeyChartData('Sales Growth',"#1f497d");
      //this.getCostMetricsChartData('Price/Sales (x)');

    },400)
    
  },
 
  methods: {
    ...mapActions(["setDownloadInfo", "getChartDataById"]),
    resetSliders(){
      this.value1 = 0
      this.value2 = 0
      this.value3 = 0
      this.value4 = 0
      this.value5 = 0
      this.value6 = 0
      this.value7 = 0
      this.sliderValuesChange()
    },
    sliderValuesChange(){
      this.balancesheetTableDataLocal = []
      for(let [idx,i] of this.formatdata(this.balancesheet).entries()){
        if(this.value1){
          if (i["key"] == "Cash and cash equivalents") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-230 * this.value1)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-234 * this.value1)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-232 * this.value1)).toFixed(2));
          } else if (i["key"] == "Net Cash") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value1)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value1)).toFixed(2));   
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value1)).toFixed(2));
          } else if (i["key"] == "Total Current Asset") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (92 * this.value1)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (470 * this.value1)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (870 * this.value1)).toFixed(2));
          } else if (i["key"] == "Total assets") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value1)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value1)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value1)).toFixed(2));
          } else if (i["key"] == "Total liabilities") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value1)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value1)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value1)).toFixed(2));
          }

        }
        if(this.value2){
          if (i["key"] == "Cash and cash equivalents") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-230 * this.value2)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-234 * this.value2)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-232 * this.value2)).toFixed(2));
          } else if (i["key"] == "Net Cash") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value2)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value2)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value2)).toFixed(2));
          } else if (i["key"] == "Total Current Asset") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (92 * this.value2)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (470 * this.value2)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (870 * this.value2)).toFixed(2));
          } else if (i["key"] == "Total assets") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value2)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value2)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value2)).toFixed(2));
          } else if (i["key"] == "Total liabilities") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value2)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value2)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value2)).toFixed(2));
          }
        }
        if(this.value3){
          if (i["key"] == "Cash and cash equivalents") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-230 * this.value3)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-234 * this.value3)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-232 * this.value3)).toFixed(2));
          } else if (i["key"] == "Net Cash") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value3)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value3)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value3)).toFixed(2));
          } else if (i["key"] == "Total Current Asset") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (92 * this.value3)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (470 * this.value3)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (870 * this.value3)).toFixed(2));
          } else if (i["key"] == "Property, plant & equipment") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-92 * this.value3)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-465 * this.value3)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-870 * this.value3)).toFixed(2));
          }
          
        }
        if(this.value4){
          if (i["key"] == "Cash and cash equivalents") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-230 * this.value4)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-234 * this.value4)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-232 * this.value4)).toFixed(2));
          } else if (i["key"] == "Net Cash") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value4)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value4)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value4)).toFixed(2));
          } else if (i["key"] == "Total Current Asset") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (92 * this.value4)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (470 * this.value4)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (870 * this.value4)).toFixed(2));
          }
          
        }
        if(this.value5){
          if (i["key"] == "Cash and cash equivalents") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-230 * this.value5)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-234 * this.value5)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-232 * this.value5)).toFixed(2));
          } else if (i["key"] == "Net Cash") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value5)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value5)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value5)).toFixed(2));
          } else if (i["key"] == "Total Current Asset") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (92 * this.value5)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (470 * this.value5)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (870 * this.value5)).toFixed(2));
          } else if (i["key"] == "Property, plant & equipment") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-92 * this.value5)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-465 * this.value5)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-870 * this.value5)).toFixed(2));
          }
          
        }
        if(this.value6){
          if (i["key"] == "Cash and cash equivalents") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-230 * this.value6)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-234 * this.value6)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-232 * this.value6)).toFixed(2));
          }
          
        }
        if(this.value7){
          if (i["key"] == "Cash and cash equivalents") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (-230 * this.value7)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (-234 * this.value7)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (-232 * this.value7)).toFixed(2));
          } else if (i["key"] == "Net Cash") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value7)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value7)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value7)).toFixed(2));
          } else if (i["key"] == "Total Current Asset") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (92 * this.value7)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (470 * this.value7)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (870 * this.value7)).toFixed(2));
          } else if (i["key"] == "Total assets") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value7)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value7)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value7)).toFixed(2));
          } else if (i["key"] == "Total liabilities") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (207 * this.value7)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (210 * this.value7)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (210 * this.value7)).toFixed(2));
          }
          
        }
        
        this.balancesheetTableDataLocal.push(i)
        this.getbalancesheetChartData(this.filterChartTab)
      }
      this.analysisTableDataLocal = []
      for(let [idx,i] of this.formatdata(this.analysis).entries()){
        if(this.value1){
          if (i.key == "Net Cash per share" || i.key == "Cash per share") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.03 * this.value1)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.03 * this.value1)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.03 * this.value1)).toFixed(2));
          }
        }
        if(this.value2){
          if (i.key == "Net Cash per share" || i.key == "Cash per share") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.03 * this.value2)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.03 * this.value2)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.03 * this.value2)).toFixed(2));
          }
        }
        if(this.value3){
          if (i.key == "Net Cash per share" || i.key == "Cash per share") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.03 * this.value3)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.03 * this.value3)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.03 * this.value3)).toFixed(2));
          }
        }
        if(this.value4){
          if (i.key == "Net Cash per share" || i.key == "Cash per share") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.03 * this.value4)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.03 * this.value4)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.03 * this.value4)).toFixed(2));
          }
        }
        if(this.value5){
          if (i.key == "Net Cash per share" || i.key == "Cash per share") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.03 * this.value5)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.03 * this.value5)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.03 * this.value5)).toFixed(2));
          }
        }
        if(this.value6){
          if (i.key == "Net Cash per share" || i.key == "Cash per share") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.03 * this.value6)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.03 * this.value6)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.03 * this.value6)).toFixed(2));
          }
        }
        if(this.value7){
          if (i.key == "Net Cash per share" || i.key == "Cash per share") {
            i["2019E"] = Number((parseFloat(i["2019E"]) + (0.03 * this.value7)).toFixed(2));
            i["2020E"] = Number((parseFloat(i["2020E"]) + (0.03 * this.value7)).toFixed(2));
            i["2021E"] = Number((parseFloat(i["2021E"]) + (0.03 * this.value7)).toFixed(2));
          }
        }
        this.analysisTableDataLocal.push(i)
        this.getanalysisChartData(this.filterChartTabAna)
      }
    },
    formatdata(mapData) {
      let tableData = [];
      if (
        typeof mapData.category != "undefined" &&
        mapData.category.length > 0
      ) {
        for (var i = 0; i < mapData.category.length; i++) {
          tableData.push({ key: mapData.category[i] });
          if (typeof mapData.xaxis != "undefined") {
            for (var j = 0; j < mapData.xaxis.length; j++) {
              let cat = mapData.category[i].toLowerCase().replace(/\s/g, "");
              tableData[i][mapData.xaxis[j]] = mapData[cat][j];
            }
          } else {
            for (var k = 0; k < mapData.yaxis.length; k++) {
              let cat = mapData.category[i].toLowerCase().replace(/\s/g, "");
              tableData[i][mapData.yaxis[k]] = mapData[cat][k];
            }
          }
        }
      }
      if (tableData.length > 0) {
        if (this.analysisCalc) {
          this.analysisCalc = false;
          this.getanalysisChartData("Net Cash per share");
        }

        if (this.balancesheetCalc) {
          this.balancesheetCalc = false;
          this.getbalancesheetChartData("Cash and cash equivalents");
        }
      }
      return tableData;
    },
    renderBSChart(filter,xaxis,yaxis){
        this.balancesheetChartData[0].name = filter;
        this.balancesheetChartData[0].x = xaxis;
        this.balancesheetChartData[0].y = [];
        this.balancesheetChartData[0].y = yaxis;
        let maxVal = Math.max(yaxis);
        let minVal = Math.min(yaxis);
        this.Linelayout.yaxis.range[0] = minVal;
        this.Linelayout.yaxis.range[1] = maxVal;
        this.balancesheetChartData[1].x = xaxis;
        let yoyData = yaxis;
        this.balancesheetChartData[1].y = [];
        for (let i = 0; i < yoyData.length; i++) {
          let yoy = 0;
          if (i > 0) {
            yoy = (
              ((yoyData[i] - yoyData[i - 1]) / yoyData[i - 1]) *
              100
            ).toFixed(1);
          }
          this.balancesheetChartData[1].y.push(yoy);
        }
        let maxValYoY = Math.max(this.balancesheetChartData[1].y);
        let minValYoY = Math.min(this.balancesheetChartData[1].y);
        this.Linelayout.yaxis2.range[0] = minValYoY;
        this.Linelayout.yaxis2.range[1] = maxValYoY;

    },
    getbalancesheetChartData(filter) {
      let self = this
      this.filterChartTab = filter
      let debt = {}
      let equity = {}
      if(filter=="D/E"){
        for(let [i,d] of self.balancesheetTableDataLocal.entries()){
          if(d.key=="Debt"){
            debt = d
          }
          else if(d.key=="Total shareholders' equity"){
            equity = d
          }
        }
      }
      let balanceSheet = JSON.parse(sessionStorage.getItem("balancesheet"));
      setTimeout(function(){
        let xaxis = balanceSheet.yaxis //wrong key from backend in response json it should be xaxis(years which will show on x axis)
        let yaxis = []
        for(let [i,d] of self.balancesheetTableDataLocal.entries()){
          if(filter == d.key && filter != 'D/E' ) {
            for(let [yi,yd] of xaxis.entries()){
              yaxis.push(d[yd])
            }
          } 
          else if(filter=='D/E'){
            for(let [yi,yd] of xaxis.entries()){
              yaxis.push(Number(debt[yd]/equity[yd]).toFixed(2))
            }
          }
        }
        self.renderBSChart(filter,xaxis,yaxis)
      },100)

    },
    renderAnalysisChart(filter,xaxis,yaxis){
        this.analysisChartData[0].name = filter;
        this.analysisChartData[0].x = xaxis;
        this.analysisChartData[0].y = [];
        this.analysisChartData[0].y = yaxis;
     
      
        this.analysisChartData[1].x = xaxis;
        let yoyData = yaxis;
        this.analysisChartData[1].y = [];
        for (let i = 0; i < yoyData.length; i++) {
          let yoy = 0;
          if (i > 0) {
            yoy = (
              ((yoyData[i] - yoyData[i - 1]) / yoyData[i - 1]) *
              100
            ).toFixed(1);
          }
          this.analysisChartData[1].y.push(yoy);
        }
       
      

    },
    getanalysisChartData(filter) {
      let self = this
      this.filterChartTabAna = filter
      let analysisData = JSON.parse(sessionStorage.getItem("analysis"));
      setTimeout(function(){
        let xaxis = analysisData.xaxis 
        let yaxis = []
        for(let [i,d] of self.analysisTableDataLocal.entries()){
          if(filter == d.key ) {
            for(let [yi,yd] of xaxis.entries()){
              yaxis.push(d[yd])
            }
          } 
        }
        self.renderAnalysisChart(filter,xaxis,yaxis)
      },100)
    },
  },
  mounted() {
    var self = this
    setTimeout(function(){

      self.balancesheetTableDataLocal = self.formatdata(self.balancesheet);
      self.analysisTableDataLocal = self.formatdata(self.analysis);
      let filterChart = self.iMostChildren.filter(
        (item) => "BS Drivers" === item.objectname
      );
      // console.log('filterChart-==',filterChart);
      let snapshopChild = filterChart[0].child;
      for (var i = 0; i < snapshopChild.length; i++) {
        self.getChartDataById({
          id: snapshopChild[i].chartId,
          chartName: snapshopChild[i].objectname,
        });
      }

      self.setDownloadInfo({
        fileName: "bsDrivers",
        downloadData: self.$refs.capture,
      });
      // self.getKeyChartData('Sales Growth',"#1f497d");
      // self.getCostMetricsChartData('Price/Sales (x)');

    },400)
    
  },
  filters: {
    roundOff(num) {
      return isNaN(num) ? num : num.toFixed(2);
    },
    roundOffPer(num) {
      return isNaN(num) ? num : (num * 100).toFixed(1) + "%";
    },
    currencyFormat(num) {
      return isNaN(num) ? num : "$" + num;
    },
  },
};
</script>

<style>
.tblWrapper {
  margin-bottom: 12px;
}
.tblWrapper h5 {
  font-size: 1rem;
  padding-top: 10px;
}
.tblWrapper table {
  border: 1px solid;
  position: relative;
  width: 100%;
  font-size: 11px;
  border: none;
}
.tblWrapper table thead {
  width: 100%;
  background: #fff;
  color: #333;
  text-align: left;
  font-size: 11px;
}
.bsDriversPanel {
  max-height: 45vh;
  overflow: auto;
}
.bsDriversPanel .card-header {
  padding: 0rem 0.2rem;
  font-size: 0.9rem;
}
.rightAligned {
  text-align: right;
}
.bsDriversPanel .card-body {
  padding: 0.25rem;
}
.bsDriversHeader .exportDropDown .btn,
.bsDriversHeader .fullscreenBtn {
  padding: 0 5px;
}
.bsDriversPanel .filterBtn .btn {
  margin-right: 5px;
  padding: 0.2rem 0.5rem !important;
  font-size: 0.9rem;
}
.bsDriversPanel .filterBtn {
  margin: 0 auto;
}
</style>
